export default __webpack_public_path__ + "static/media/smartMirror7.ba84d610.jpg";